import { useState, useEffect } from 'react';
import { getAuth, RecaptchaVerifier } from 'firebase/auth';

// Import variables
import { LOCAL_STORAGE_LANGUAGE } from 'helpers/variables';

import { RECAPTCHA_CONTAINER_ID, RECAPTCHA_TYPE } from './helpers';

const useRecaptcha = (onUpdate) => {
	const [isRecaptchaLoading, setIsRecaptchaLoading] = useState(true);
	const auth = getAuth();

	const recaptchaInitialization = async () => {
		auth.languageCode = localStorage.getItem(LOCAL_STORAGE_LANGUAGE) || 'pl';

		window.recaptchaVerifier = new RecaptchaVerifier(
			RECAPTCHA_CONTAINER_ID,
			{
				size: RECAPTCHA_TYPE,
				callback: () => onUpdate(true),
				'expired-callback': () => onUpdate(false),
				theme: 'dark'
			},
			auth
		);

		const widgetId = await window.recaptchaVerifier.render();
		window.recaptchaWidgetId = widgetId;
		setIsRecaptchaLoading(false);
	};

	useEffect(() => {
		recaptchaInitialization();
		// eslint-disable-next-line
	}, []);

	return {
		isRecaptchaLoading
	};
};

export default useRecaptcha;
